var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7955 7.0455C11.2348 6.60616 11.2348 5.89384 10.7955 5.4545C10.3562 5.01517 9.64385 5.01517 9.2045 5.4545L5.4545 9.2045C5.34039 9.31862 5.25592 9.45115 5.20108 9.59252C5.15826 9.70267 5.13229 9.82124 5.12633 9.94506C5.11851 10.1062 5.14513 10.2686 5.20621 10.4205C5.26113 10.557 5.34389 10.6849 5.4545 10.7955L9.2045 14.5455C9.64385 14.9848 10.3562 14.9848 10.7955 14.5455C11.2348 14.1062 11.2348 13.3938 10.7955 12.9545L8.96601 11.125H17.5C21.1154 11.125 23.875 13.789 23.875 16.875C23.875 19.961 21.1154 22.625 17.5 22.625H7.50002C6.87869 22.625 6.37502 23.1287 6.37502 23.75C6.37502 24.3713 6.87869 24.875 7.50002 24.875H17.5C22.1697 24.875 26.125 21.384 26.125 16.875C26.125 12.366 22.1697 8.87502 17.5 8.87502H8.96598L10.7955 7.0455Z",
    fill: "#FCFCFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.8c84d9485bdfb84cf4506dadab0959ad.svg";
export { ForwardRef as ReactComponent };